export default "__VITE_ASSET__$dE$O9$Z__"